/**
 * 미션 마무리 화면 — OX 퀴즈·사진찍기 **공용** (Figma `3601:43294` / `3601:45510`)
 *
 * 사용자 요청 원문: *"… 보여준 후 이 피그마 링크를 4초 보여주고 QR대기화면으로 넘어가도록"*
 *
 * 구성: 베이지 그라데이션 + 전체 배경 그림 + 좌측 캐릭터 + 우측 "미션 대성공!" 타이틀.
 *
 * 🔴 **2026-08-14 에 사진찍기도 이 화면으로 합류**했다(Figma 3601:45510 — OX 노드와 좌표까지
 *    동일). 그래서 이름에서 `OxQuiz` 접두를 떼었다 — 두 미션이 쓰는데 한쪽 이름을 달면
 *    다음 사람이 "OX 전용인가?" 하고 헷갈린다.
 *    ⚠️ 그 결과 옛 나무판 게시판(`MissionSuccessBoard`)은 **완전한 고아**가 됐다.
 *       파일은 지우지 않고 "다시 참조되면 알려주는" 가드로 뒤집어 뒀다.
 *
 * 🔴 **`object-fit` 을 지정하지 않는다** — 피그마 코드가 `size-full` 만 주어 CSS 기본값
 *    `fill`(늘림)로 렌더된다. 캐릭터는 가로로 ~6%, 타이틀은 세로로 ~31% 눌리는데
 *    **디자이너의 렌더 결과가 그러하므로 그대로 재현한다.** 임의로 `contain` 을 쓰면
 *    디자인과 다른 화면이 된다(검증은 피그마 참조 렌더와 픽셀 대조 — S11).
 *
 * 회귀 가드: OxQuizVerdict.test.jsx
 */
import React from 'react';
import './OxQuizFlow.css';

export default function MissionDoneScreen() {
  return (
    <div className="oxq-screen oxq-screen-beige oxq-done" data-testid="ox-quiz-done">
      <span className="oxq-done-bg" aria-hidden="true" />
      <span className="oxq-done-char" aria-hidden="true" />
      {/* 타이틀 그림이 "미션 대성공!" 문구를 담는다 — 스크린리더용 대체 텍스트를 남긴다 */}
      <span className="oxq-done-title" role="img" aria-label="미션 대성공!" />
    </div>
  );
}
